import firebase from "firebase";
import pkg from "../../package.json";
import firebaseConfig from "../firebaseConfig";
import StackdriverErrorReporter from "stackdriver-errors-js";

const isProduction = process.env.NODE_ENV === "production";
const isWorker = typeof window === "undefined";

export const appVersion = pkg.version;

const STACKDRIVER_CONFIG = {
  key: firebaseConfig.apiKey,
  projectId: firebaseConfig.projectId,
  version: appVersion,
  disabled: !isProduction,
  service: "vorsorge360",
};

// Only initialize Stackdriver if we're not in a Web Worker
let errorHandler = null;
if (!isWorker) {
  errorHandler = new StackdriverErrorReporter();
  errorHandler.start(STACKDRIVER_CONFIG);
}

export const logError = (e, context) => {
  const isAxiosNetworkError =
    e &&
    typeof e === "object" &&
    (e.isAxiosError || e.name === "AxiosError") &&
    !e.response &&
    (e.code === "ERR_NETWORK" ||
      e.message === "Network Error" ||
      e.message?.toLowerCase?.().includes("network error"));
  if (isAxiosNetworkError) {
    return; // Don't log network errors from Axios
  }
  if (isProduction && !isWorker) {
    const user = firebase.auth().currentUser;
    if (user) {
      errorHandler.setUser(user.uid);
    }
    if (context) {
      if (typeof e === "string") {
        e = new Error(`${e} – Context: ${JSON.stringify(context)}`); // Can't add custom context with "stackdriver-errors-js", so we add it to the error message.
      }
    }
    errorHandler.report(e);
  } else {
    console.error(e);
    if (context) {
      console.log(
        `The previous error was caused by this context: ${JSON.stringify(
          context
        )}`
      );
    }
  }
};
